module.exports = __webpack_public_path__ + "static/img/bind_allonePro.4dd50e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect/bind_allonePro.png
// module id = 750
// module chunks = 1